import { IAxiosResponseWithError, network } from "@utils/network/network";

export const getContractKeyRequest = async (): Promise<IAxiosResponseWithError<{ key: string }>> => {
  return await network.request<{ key: string }>("order", "customer/contract/details", {
    method: "GET",
  });
};
